/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { Service } from "./Service";
import * as t from "io-ts";

// required attributes
const ServicesR = t.interface({
  page_info: PageInfo,

  services: t.readonlyArray(Service, "array of Service")
});

// optional attributes
const ServicesO = t.partial({});

export const Services = t.intersection([ServicesR, ServicesO], "Services");

export type Services = t.TypeOf<typeof Services>;
